module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: {
      'pb100': _vm.showMenue
    },
    attrs: {
      "id": "app"
    }
  }, [(_vm.showMenue) ? _c('base-nav', {
    ref: "nav"
  }) : _vm._e(), _vm._v(" "), _c('keep-alive', [(_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e()], 1), _vm._v(" "), (!_vm.$route.meta.keepAlive) ? _c('router-view') : _vm._e(), _vm._v(" "), _c('FirstShop', {
    attrs: {
      "firstDialog": _vm.firstDialog
    },
    on: {
      "hiddenFirstDialog": function($event) {
        _vm.firstDialog = false
      }
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-14f95600!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 1421
// module chunks = 131